import Vue from 'vue';
import Vuex from 'vuex';


Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    token: '',
    sid:'',
    startTime: '',
    expires_in: '',
    userInfo:JSON.parse(sessionStorage.getItem('userInfo')) || {},
    limitPath:JSON.parse(sessionStorage.getItem('limitPath')) || [],
    viewButton:JSON.parse(sessionStorage.getItem('viewButton')) || [],
    staticData:JSON.parse(sessionStorage.getItem('staticData')) || {},
    positionId:sessionStorage.getItem('positionId') || '',
    step:sessionStorage.getItem('step') || '',
    currentCaseId:sessionStorage.getItem('currentCaseId') || '',
    adjustCaseId:sessionStorage.getItem('adjustCaseId') || '',
    restartCase:sessionStorage.getItem('restartCase') || '',

    tabIndex:sessionStorage.getItem('tabIndex')||0,
    pageNum: sessionStorage.getItem('pageNum') || 1,
    pageSize: sessionStorage.getItem('pageSize') || 10,
    filterState: sessionStorage.getItem('filterState') || '',
    designCenterTabIndex: sessionStorage.getItem('designCenterTabIndex')||0,
    designCenterPageNum: sessionStorage.getItem('designCenterPageNum') || 1,
    designCenterPageSize: sessionStorage.getItem('designCenterPageSize') || 10,
    designCenterFilterState: sessionStorage.getItem('designCenterFilterState') || '',

    patientPageNum: sessionStorage.getItem('patientPageNum') || 1,
    patientPageSize: sessionStorage.getItem('patientPageSize') || 10,
    packageFilter:JSON.parse(sessionStorage.getItem('packageFilter'))||[],
    genderFilter:JSON.parse(sessionStorage.getItem('genderFilter'))||[],
    clinicalSettingFilter:JSON.parse(sessionStorage.getItem('clinicalSettingFilter'))||[],
    correctionFilter:JSON.parse(sessionStorage.getItem('correctionFilter'))||[],
    treatmentInfo:JSON.parse(sessionStorage.getItem('treatmentInfo')) || {},
    titleSelection:JSON.parse(sessionStorage.getItem('titleSelection'))||[],
    navigateInfo:JSON.parse(sessionStorage.getItem('navigateInfo'))|| {},
    caseBasicInfo:JSON.parse(sessionStorage.getItem('caseBasicInfo'))|| {},
    searchParams:sessionStorage.getItem('searchParams')|'',
    patientInfo:JSON.parse(sessionStorage.getItem('patientInfo'))||{},
    patientLoginPwd:sessionStorage.getItem('patientLoginPwd') || '',
  },
  mutations: {
    //导航守卫
    setToken(state, { expires_in, token, sid, startTime}) {
      state.expires_in = expires_in;
      state.token = token;
      state.sid = sid;
      state.startTime = startTime;
      // console.log(state.token);
    },
    //基本信息
    userInfo(state,userInfo){
      sessionStorage.setItem('userInfo',JSON.stringify(userInfo))
      state.userInfo=userInfo;
    },
    //修改病例的限制
    limitCase(state,path){
      sessionStorage.setItem('limitPath',JSON.stringify(path))
      state.limitPath=path;
    },
    //视图权限
    viewInfo(state,buttonId){
      sessionStorage.setItem('viewButton',JSON.stringify(buttonId))
      state.viewButton=buttonId;
    },
    //静态资源
    staticRes(state,staticData){
      sessionStorage.setItem('staticData',JSON.stringify(staticData))
      state.staticData=staticData;
    },
    //登录用户id
    positionId(state,positionId){
      sessionStorage.setItem('positionId',positionId)
      state.positionId=positionId;
    },
    //新建病例当前到哪一步了
    createCaseStep(state,step){
      sessionStorage.setItem('step',step)
      state.step=step;
    },
    //修改病例CaseId
    currentCaseId(state,currentCaseId){
      sessionStorage.setItem('currentCaseId',currentCaseId);
      state.currentCaseId=currentCaseId;
    },
    //阶段调整病例caseId
    adjustCaseId(state,adjustCaseId){
      sessionStorage.setItem('adjustCaseId',adjustCaseId)
      state.adjustCaseId=adjustCaseId;
    },
    //病例重启标识
    restartCase(state,restartCase){
      sessionStorage.setItem('restartCase',restartCase)
      state.restartCase=restartCase;
    },

    //返回上一页面 参数
    pageNum_store(state,pageNum){
      sessionStorage.setItem('pageNum',pageNum)
      state.pageNum=pageNum;
    },
   //返回上一页面 参数
    pageSize_store(state,pageSize){
      sessionStorage.setItem('pageSize',pageSize)
      state.pageSize=pageSize;
    },

    //返回上一页面 参数
    patientPageNum_store(state,patientPageNum){
      sessionStorage.setItem('patientPageNum',patientPageNum)
      state.patientPageNum=patientPageNum;
    },
    //返回上一页面 参数
    patientPageSize_store(state,patientPageSize){
      sessionStorage.setItem('patientPageSize',patientPageSize)
      state.patientPageSize=patientPageSize;
    },
    //病例页根据tab筛选参数
    filterState_store(state,filterState){
      sessionStorage.setItem('filterState',filterState)
      state.filterState=filterState;
    },

    //工作中心筛选
    packageFilter_store(state,packageFilter){
      sessionStorage.setItem('packageFilter',JSON.stringify(packageFilter))
      state.packageFilter = packageFilter;
    },
    //性别筛选
    genderFilter_store(state,genderFilter){
      sessionStorage.setItem('genderFilter',JSON.stringify(genderFilter))
      state.genderFilter = genderFilter;
    },
    //诊断信息筛选
    clinicalSettingFilter_store(state,clinicalSettingFilter){
      sessionStorage.setItem('clinicalSettingFilter',JSON.stringify(clinicalSettingFilter))
      state.clinicalSettingFilter = clinicalSettingFilter;
    },
    //矫正方法筛选
    correctionFilter_store(state,correctionFilter){
      sessionStorage.setItem('correctionFilter',JSON.stringify(correctionFilter))
      state.correctionFilter = correctionFilter;
    },
    //3D方案信息参数传递
    treatmentInfo_store(state,treatmentInfo){
      sessionStorage.setItem('treatmentInfo',JSON.stringify(treatmentInfo))
      state.treatmentInfo = treatmentInfo;
    },

    setTitleSelection(state,titleSelection){
      sessionStorage.setItem('titleSelection',JSON.stringify(titleSelection))
      state.titleSelection=titleSelection;
    },
    //返回上一页左侧导航栏  参数
    setNavigateInfo(state,navigateInfo){
      sessionStorage.setItem('navigateInfo',JSON.stringify(navigateInfo));
      state.navigateInfo=navigateInfo;
    },

    //病例页tab页   参数
    setTabIndex(state,tabIndex){
      sessionStorage.setItem('tabIndex',tabIndex);
      state.tabIndex=tabIndex;
    },
    //创建病例基本信息
    caseBasicInfo(state,caseBasicInfo){
      sessionStorage.setItem('caseBasicInfo',JSON.stringify(caseBasicInfo));
      state.caseBasicInfo=caseBasicInfo;
    },
    searchParams(state,searchParams){
      sessionStorage.setItem('searchParams',searchParams);
      state.searchParams=searchParams;
    },
    patientInfo(state,patientInfo){
      sessionStorage.setItem('patientInfo',JSON.stringify(patientInfo));
      state.patientInfo=patientInfo;
    },
    //患者登陆密码
    patientLoginPwd(state,patientLoginPwd){
      sessionStorage.setItem('patientLoginPwd',patientLoginPwd)
      state.patientLoginPwd=patientLoginPwd;
    },

    //病例页tab页   参数
    setDesignCenterTabIndex(state,designCenterTabIndex){
      sessionStorage.setItem('designCenterTabIndex',designCenterTabIndex);
      state.designCenterTabIndex=designCenterTabIndex;
    },
    //返回上一页面 参数
    setDesignCenterPageNum(state,designCenterPageNum){
      sessionStorage.setItem('designCenterPageNum',designCenterPageNum)
      state.designCenterPageNum=designCenterPageNum;
    },
    //返回上一页面 参数
    setDesignCenterPageSize(state,designCenterPageSize){
      sessionStorage.setItem('designCenterPageSize',designCenterPageSize)
      state.designCenterPageSize=designCenterPageSize;
    },
    //病例页根据tab筛选参数
    setDesignCenterFilterState(state,designCenterFilterState){
      sessionStorage.setItem('designCenterFilterState',designCenterFilterState)
      state.designCenterFilterState=designCenterFilterState;
    },
  },

});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js